import { Alert, Skeleton, Stack } from '@all-manager/design-system-v2';
import ReminderCard from "../../../providers/components/ProviderDetails/ReminderCard/ReminderCard";
import useGetReminder from "../../api/useGetReminder";

type Props = {
  id: string;
};

const SKELETON_WIDTH = 280;

export default function ReminderDetail(props: Props) {
  const { data: reminder, isLoading, error } = useGetReminder(props.id);

  function renderContent() {
    if (isLoading) {
      return (
        <Stack spacing={1} aria-busy="true" aria-label="Chargement du rappel">
          <Skeleton variant="text" width={SKELETON_WIDTH} />
          <Skeleton variant="text" width={SKELETON_WIDTH * 0.6} />
          <Skeleton variant="rounded" width={SKELETON_WIDTH} height={32} />
        </Stack>
      );
    }

    if (error || !reminder) {
      return (
        <Alert severity="error">
          Le rappel n'a pas pu être chargé. Fermez puis rouvrez-le pour réessayer.
        </Alert>
      );
    }

    return <ReminderCard reminder={reminder} displayProvider displaySubject />;
  }

  return renderContent();
}
